/* eslint-disable no-console */
import { FC } from 'react';

import { timeAgo } from '@utils/time-ago';
import { Box } from '@versumstudios/ui';

interface IDateComponent {
  timestamp: string;
}

export const DateComponent: FC<IDateComponent> = ({ timestamp }) => {
  return <Box css={{ fontSize: 14, color: '$secondaryFill' }}>{timeAgo.format(new Date(timestamp))}</Box>;
};
